














import { defineComponent } from '@vue/composition-api';

import CommonFormWithCashFlowEditor from '@/components/CashFlow/CommonFormWithCashFlowEditor.vue';
import CommonDropzoneWithCashFlowUpload from '@/components/CashFlow/CommonDropzoneWithCashFlowUpload.vue';

const CreateVehicleCashflow = defineComponent({
  components: {
    CommonFormWithCashFlowEditor,
    CommonDropzoneWithCashFlowUpload,
  },
  // setup() {},
});

export default CreateVehicleCashflow;
